import React from "react";

// Components imports
import InputField from "../../../common/InputField";

// Scss imports
import css from "./Contact.module.scss";

interface ContactProps {
  phone: string;
  email: string;
  handleChange: Function;
  errorText: string;
  phoneError: string;
  emailError: string;
}

const Contact: React.FC<ContactProps> = ({
  email,
  phone,
  handleChange,
  errorText,
  phoneError,
  emailError
}) => {
  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Број"
          name="phone"
          id="name"
          type="text"
          placeholder="646654656466"
          value={phone}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "646654656466")}
          errorText={phoneError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Имејл"
          name="email"
          id="email"
          type="text"
          placeholder="jonathan@gmail.com"
          value={email}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) =>
            (e.target.placeholder = "jonathan@gmail.com")
          }
          errorText={emailError}
        />
      </div>
    </div>
  );
};

export default Contact;
